import { FormMultaNaoAcompanhadaDadosDefesa } from "./Steps/FormMultaNaoAcompanhadaDadosDefesa";
import { FormMultaNaoAcompanhadaDadosMulta } from "./Steps/FormMultaNaoAcompanhadaDadosMulta";
import { FormMultaNaoAcompanhadaDadosPessoais } from "./Steps/FormMultaNaoAcompanhadaDadosPessoais";
import { FormMultaNaoAcompanhadaParaQuem } from "./Steps/FormMultaNaoAcompanhadaParaQuem";

export const formMultaNaoAcompanhadaSteps = Object.freeze([
    {
        title: 'Cadastrar Multa:',
        FormComponent: FormMultaNaoAcompanhadaParaQuem,
    },
    {
        title: 'Dados Pessoais:',
        FormComponent: FormMultaNaoAcompanhadaDadosPessoais,
    },
    {
        title: 'Dados da Multa:',
        FormComponent: FormMultaNaoAcompanhadaDadosMulta,
    },
    {
        title: 'Dados da Defesa:',
        FormComponent: FormMultaNaoAcompanhadaDadosDefesa,
    },
]);